import React from "react";
import { FLAG_DATES, FLAG_MEDIA, FLAG_TITLES, STARTING_LINE_INDEX, STARTING_LINE_TEXT } from "../constants";

type BuildingModalProps = {
  isOpen: boolean;
  buildingIndex: number | null;
  onClose: () => void;
};

export default function BuildingModal({
  isOpen,
  buildingIndex,
  onClose,
}: BuildingModalProps) {
  if (!isOpen || buildingIndex === null) return null;

  // Check if this is the starting line flag
  const isStartingLine = buildingIndex === STARTING_LINE_INDEX;
  
  const date = isStartingLine ? "" : (FLAG_DATES[buildingIndex] || "01-01-2025");
  const title = isStartingLine ? "" : (FLAG_TITLES[buildingIndex] || "");
  const mediaItems = isStartingLine ? [] : (FLAG_MEDIA[buildingIndex] || []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: 12,
          padding: 0,
          maxWidth: 600,
          width: "90%",
          maxHeight: "90vh",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
          display: "flex",
          flexDirection: "column",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header - fixed */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 24,
            paddingBottom: 16,
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          <h2 style={{ margin: 0, fontSize: 24, color: "#1f2937", fontFamily: "sans-serif" }}>
            {isStartingLine ? "Starting Line" : title}
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: 28,
              cursor: "pointer",
              color: "#6b7280",
              padding: "4px 8px",
              lineHeight: 1,
            }}
          >
            ×
          </button>
        </div>

        {/* Scrollable content */}
        <div
          style={{
            overflowY: "auto",
            padding: 24,
            flex: 1,
          }}
        >
          {/* Date (only for regular flags) */}
          {/* {!isStartingLine && (
            <p style={{ margin: 0, marginBottom: 20, color: "#4b5563", lineHeight: 1.6, fontSize: 18, fontWeight: "bold", fontFamily: "sans-serif" }}>
              Date: {date}
            </p>
          )} */}

          {/* Starting line text or placeholder text */}
          {isStartingLine ? (
            <p style={{ margin: 0, marginBottom: 24, color: "#4b5563", lineHeight: 1.8, fontSize: 18, fontFamily: "sans-serif" }}>
              {STARTING_LINE_TEXT}
            </p>
          ) : (
            <p>
              {/* This is placeholder text for Flag {buildingIndex + 1}. You can add descriptions, stories, or any other information about this location here. The content can be as long as needed and will scroll within the modal. */}
            </p>
          )}

          {/* Media items (images and videos) - only for regular flags */}
          {!isStartingLine && mediaItems.length > 0 ? (
            mediaItems.map((media, index) => (
              <div
                key={index}
                style={{
                  width: "100%",
                  backgroundColor: "#e5e7eb",
                  borderRadius: 8,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: index < mediaItems.length - 1 ? 16 : 0,
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                {media.type === 'image' ? (
                  <img
                    src={media.src}
                    alt={`Flag ${buildingIndex + 1} - Media ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                    }}
                  />
                ) : (
                  <video
                    src={media.src}
                    controls
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                    }}
                  >
                    Your browser does not support the video tag.
                  </video>
                )}
              </div>
            ))
          ) : !isStartingLine ? (
            // Show placeholder if no media (only for regular flags)
            <div
              style={{
                width: "100%",
                height: 300,
                backgroundColor: "#e5e7eb",
                borderRadius: 8,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "black",
                fontSize: 30,
              }}
            >
              <div style={{ fontFamily: "sans-serif" }}>???</div>
            </div>
          ) : null}

          {/* Additional placeholder text at the bottom (only for regular flags) */}
          {!isStartingLine && (
            <p style={{ margin: 0, marginTop: 24, color: "#6b7280", lineHeight: 1.6, fontSize: 16, fontFamily: "sans-serif" }}>
              {/* More placeholder text can go here. This section demonstrates that the modal is scrollable and can contain a lot of content. You can add as much text and images as needed. */}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

